export class CategoryAxisModel {
  name?: string;
  min?: number;
  max?: number;
  categories?: any[];
}
